import request from '@/utils/request'
import StorageWithExpiry from '@/utils/st'

export function create(data) {

  return request({
    url: '/organizationCheckItemStatus/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/organizationCheckItemStatus/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/organizationCheckItemStatus/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/organizationCheckItemStatus/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/organizationCheckItemStatus/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/organizationCheckItemStatus/getByIds',
    method: 'GET',
    params})
}

   

export async function list(params) {
    var res = StorageWithExpiry.getItem("__organizationCheckItemStatus")
    if(res){
      return res
    }
    var re =await request({
      url: '/organizationCheckItemStatus/list',
      method: 'GET',
      params})
      StorageWithExpiry.setItem('__organizationCheckItemStatus', re, 3600 * 1000);
      return re

}

   

export function sync(data) {

  return request({
    url: '/organizationCheckItemStatus/sync',
    method: 'POST',
    data})
}

   

export function update(data) {

  return request({
    url: '/organizationCheckItemStatus/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/organizationCheckItemStatus/update/batch',
    method: 'POST',
    data})
}

   